import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#4161FF',
    },
  },
  typography: {
    h2: {
      fontWeight: 700,
      fontSize: '3.5rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '2rem',
      marginBottom: '1rem',
    },
    h6: {
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            backgroundColor: '#fff',
            '& fieldset': {
              borderColor: '#e0e0e0',
              borderWidth: '1.5px',
            },
            '&:hover fieldset': {
              borderColor: '#bdbdbd',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#4161FF',
              borderWidth: '1.5px',
            },
          },
          '& .MuiInputLabel-root': {
            '&.Mui-focused': {
              color: '#4161FF',
            },
          },
          '& .MuiOutlinedInput-input': {
            padding: '14px 16px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          border: '1px solid #e0e0e0',
          borderRadius: 8,
        },
      },
    },
  },
});

export default theme; 